// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TermsAndConditionsPage_wrapper__X3PJ_","title":"TermsAndConditionsPage_title__EODQC","content":"TermsAndConditionsPage_content__R2n3n"};